<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
    <span>位置：</span>
    <ul class="placeul">
    <li><a href="#">首页</a></li>
    <li>短信</li>
    <li><a href="#">短信签名</a></li>
    </ul>
    </div>
    
    <div class="formbody">
    
    <div class="tools lh33">

    <b>请用公司或者产品简称作为签名，不要用姓名或者电话号码，字数2-8个字。</b>
    <!-- ，阿里巴巴员工签名直接用【阿里巴巴】，阿里渠道商请用【阿里渠道】作为签名申请 ,否则将会审核不通过 -->
    </div>
    
    <ul class="forminfo">
    
    <li><label class="left">签名<b>*</b></label>【<input v-model="sign" type="text" class="dfinput" placeholder="请用公司或者产品简称作为签名，字数2-8个字" />】</li>
    <!-- <i>【签名】</i> -->
    
    <li><label>公司全名<b>*</b></label><input v-model="company" type="text" class="dfinput" placeholder="营业执照上公司全称"/></li>

    <li><label>说明<b>*</b></label><input v-model="dis" type="text" class="dfinput" placeholder="请填写具体的短信例子(否则审核可能不通过)"/></li>
    
    <li><label>商标名称<b></b></label><input v-model="sbmc" type="text" class="dfinput" placeholder="选填"/></li>

    <li><label>网址<b></b></label><input v-model="wzmc" type="text" class="dfinput" placeholder="选填"/></li>
    
    <li><label>个人名<b></b></label><input v-model="name" type="text" class="dfinput" placeholder="选填"/></li>
    
    <li>
        <label></label>
        <template v-if="num >= 5">
            <el-tag type="danger" style="font-size:14px;letter-spacing: 1px;">只能申请五个通过的签名</el-tag>
        </template>
        <template v-if="num < 5">
            <el-tooltip class="item" effect="dark" content="只能申请5个通过的短信签名" placement="right-start">
                <el-button type="primary" plain class="top_button" :disabled="signDis" @click="signApply()">申请</el-button>
            </el-tooltip>
        </template>
        <!-- <input name="" type="button" class="scbtn" value="申请" @click="signApply()"/> -->
    </li>
    
    
    </ul>
    
    <table class="tablelist">
    	<thead>
    	<tr>
            <th style="width:10%">签名 </th>
            <th style="width:10%">商标名称</th>
            <th style="width:10%">网址名称</th>
            <th style="width:10%">公司名</th>
            <th style="width:10%">个人名</th>
            <th style="width:10%">说明</th>
            <th style="width:10%">状态</th>
            <th style="width:10%">时间</th>
            <th style="width:10%">审核备注</th>
        </tr>
        </thead>
        <tbody>
        
        <tr v-for="(item,index) in signList" :class="{odd:index%2!=0}">
        <td> {{item.sign}}</td>
        <td>{{item.sbmc}}</td>
        <td>{{item.wzmc}}</td>
        <td>{{item.company}}</td>
        <td>{{item.name}}</td>
        <td>{{item.dis}}</td>
        <td>
            <ol v-if="item.status==1">审核通过</ol>
            <ol v-else-if="item.status==0" style="color:red">审核中</ol>
            <ol style="color:red" v-else-if="item.status==-1">审核未通过 <template v-if="num < 5"><label style="color: rgb(84, 151, 252);cursor: pointer;" @click="showapplyAgain(index)">修改</label></template></ol>
            <!-- <ol style="color:red" v-else-if="item.status==2">已关闭 <template v-if="num < 5"><label style="color: rgb(84, 151, 252);cursor: pointer;" @click="showapplyAgain(index)">修改</label></template></ol> -->
        </td>
        <td>{{item.createtime}}</td>
        <td>{{item.r1}}</td>
        </tr> 
        </tbody>
    </table>  

    <div v-show="applyagainShow" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
        top: 0; left: 0;display: block;"/>
    <div class="tip" style="z-index:200;display: block;width:600px;" v-show="applyagainShow">
        <div class="tiptop"><span>修改短信签名</span><a @click="closeupdate();"></a></div>
        <ul class="forminfo" style="margin-top:10px;">
            <li>
                <label>签名<b>*</b></label>
                <el-input placeholder="请用公司或者产品简称作为签名，字数2-8个字" v-model="applyagain.sign" style="width:330px;"></el-input>
            </li>
            <li>
                <label>公司全名<b>*</b></label>
                <el-input placeholder="请输入营业执照公司全称" v-model="applyagain.company" style="width:330px;"></el-input>
            </li>
            <li>
                <label>说明<b>*</b></label>
                <el-input placeholder="请填写具体的短信例子(否则审核可能不通过)" v-model="applyagain.dis" style="width:330px;"></el-input>
            </li>
            <li>
                <label>商标名称</label>
                <el-input v-model="applyagain.sbmc" placeholder="选填" style="width:330px;"></el-input>
            </li>
            <li>
                <label>网址</label>
                <el-input v-model="applyagain.wzmc" placeholder="选填" style="width:330px;"></el-input>
            </li>
            <li>
                <label>个人名</label>
                <el-input v-model="applyagain.name" placeholder="选填" style="width:330px;"></el-input>
            </li>
        </ul>
        <div class="tipbtn">
            <el-button type="primary" style="margin-left:-15px;" @click="updatesign()" :disabled="applyagain.sign.trim().length == 0 || applyagain.company.trim().length == 0 || applyagain.dis.trim().length == 0 ? true: false">确认修改</el-button>
        </div> 
    </div>
    
   
   <div class="jian">&nbsp;</div>
     <div class="welinfo">
    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
    <b>注意</b>
    </div>
    
    <ul class="infolist">
    <li><span>1、按运营商要求，部分通道强制需要签名。也方便对方知道是谁发短信给他，宣传品牌形象及更好的联系</span></li> 
    <li><span>2、每用户最多申请5个签名，每个签名2－8字（注：签名及【】均计入短信计费字数，【】占2字）</span></li> 
    <li><span>3、您选取签名后，会自动添加【】后出现在短信末尾</span></li>
    <li><span>4、可用2字以上中文公司、店铺名、商标品牌、网址等进行申请；所申请的签名需提供相关资质，经二办客服审核后方可使用</span></li>
    </ul>
    </div> 
    
    
    <div class="tip">
    	<div class="tiptop"><span>提示信息</span><a></a></div>
        
      <div class="tipinfo">
        <span><img src="../../assets/images/ticon.png" /></span>
        <div class="tipright">
        <p>是否确认对信息的修改 ？</p>
        <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
        </div>
        </div>
        
        <div class="tipbtn">
        <input name="" type="button"  class="sure" value="确定" />&nbsp;
        <input name="" type="button"  class="cancel" value="取消" />
        </div>
    
    </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            signList:[],
            sign:'',
            sbmc:'',
            wzmc:'',
            company:'',
            name:'',
            dis:'',
            num: 0,
            applyagainShow: false,
            applyagain: {
                id: 0,
                sign:'',
                sbmc:'',
                wzmc:'',
                company:'',
                name:'',
                dis:'',
            },
            signDis: false,
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getsign.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.signList = res.data.signList;
                    that.num = res.data.num;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        signApply(){
            if(this.sign.trim() == ''){
                alert("签名不能为空！");
                return;
            }
            if(this.sign.trim().length < 2 || this.sign.trim().length > 8){
                alert("签名字数请控制在2~8位！");
                return;
            }
            if(this.company.trim() == ''){
                alert("公司名称不能为空！");
                return;
            }
            if(this.dis.trim() == ''){
                alert("说明不能为空！");
                return;
            }
            this.signDis = true;
            let data = {'sign':'【' + this.sign + '】','sbmc':this.sbmc,'wzmc':this.wzmc,'company':this.company,'name':this.name,'dis':this.dis};
            let that = this;
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/insertsign.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("新签名申请成功！");
                    that.getData();
                    that.sign = '';
                    that.sbmc = '';
                    that.wzmc = '';
                    that.company = '';
                    that.name = '';
                    that.dis = '';
                }
                else
                {
                    alert(res.data.msg)
                }
                that.signDis = false;
            })
        },
        showapplyAgain(index) {
            this.applyagainShow = true;
            this.applyagain.id = this.signList[index].id;
            this.applyagain.sign = this.signList[index].sign.substring(1, this.signList[index].sign.trim().length-1);
            this.applyagain.sbmc = this.signList[index].sbmc.trim().length == 0 ? "" : this.signList[index].sbmc.trim();
            this.applyagain.wzmc = this.signList[index].wzmc.trim().length == 0 ? "" : this.signList[index].wzmc.trim();
            this.applyagain.company = this.signList[index].company.trim().length == 0 ? "" : this.signList[index].company.trim();
            this.applyagain.name = this.signList[index].name.trim().length == 0 ? "" : this.signList[index].name.trim();
            this.applyagain.dis = this.signList[index].dis.trim().length == 0 ? "" : this.signList[index].dis.trim();
        },
        closeupdate() {
            this.applyagainShow = false;
        },
        updatesign() {
            if(this.applyagain.sign.trim() == ''){
                alert("签名不能为空！");
                return;
            }
            if(this.applyagain.sign.trim().length < 2 || this.applyagain.sign.trim().length > 8){
                alert("签名字数请控制在2~8位！");
                return;
            }
            if(this.applyagain.company.trim() == ''){
                alert("公司名称不能为空！");
                return;
            }
            if(this.applyagain.dis.trim() == ''){
                alert("说明不能为空！");
                return;
            }
            this.$confirm("修改后将重新审核，确认修改？", '提示', {
                confirmButtonText: '确定', 
                cancelButtonText: '取消',                               
                type: 'warning'
            }).then( () => {
                let data = {'id': this.applyagain.id, 'sign': this.applyagain.sign.trim().length == 0 ? "": '【'  + this.applyagain.sign.trim() + '】',
                    'sbmc':this.applyagain.sbmc.trim().length == 0 ? "": this.applyagain.sbmc.trim(),'wzmc':this.applyagain.wzmc.trim().length == 0 ? "": this.applyagain.wzmc.trim(),
                    'company':this.applyagain.company.trim().length == 0 ? "": this.applyagain.company.trim(),'name':this.applyagain.name.trim().length == 0 ? "": this.applyagain.name.trim(),
                    'dis':this.applyagain.dis.trim().length == 0 ? "": this.applyagain.dis.trim()};
                let that = this;
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/updatesign.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("修改成功！");
                        that.closeupdate();
                        that.getData();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }).catch( () => {
                this.$message({
                    duration: 2000,
                    showClose: true,
                    type: 'error',
                    message: '已取消修改'
                });
            });
            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smssign.vue